<template>
  <div class="">
    <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
    <aside class="profile-nav alt">
      <section class="card">
        <div class="card-header user-header alt">
          <div class="input-group">
            <div class="input-group-btn">
                                  <span class="btn ">
                                    <i class="fa fa-search"></i> {{$t(textKey)}}
                                  </span>
            </div>
            <input v-model="val" v-on:keyup="keyupFn" type="text" id="val" placeholder="" class="form-control" name="val" @focus="onfocus">
          </div>
        </div>
        <ul class="list-group list-group-flush resultContainer">
          <template v-for="(row, i) in this.modeldata">
            <li class="list-group-item cursor" v-on:click="doEmit(row)">
              <span class="badge badge-success"> <i class="fa fa-plus"></i> </span> {{row.name}}
            </li>
          </template>
        </ul>
      </section>
    </aside>
  </div>
</template>

<script>
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import AlertInPage from '@/components/AlertInPage.vue';

  export default {
    name: 'ElementSearcher',
    data(){
      return {
        num: 0
        , val: ""
        , modeldata: []
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        }
      }
    },
    mounted() {
      console.log("ElementSearcher");
      const modul = this;
    },
    props: {
      textKey: String
    },
    watch: {
      val: function (newdata, olddata) {
        const modul = this;
        if (newdata.length >= 2) {
          modul.getElements(newdata)
        } else {
          modul.modeldata = [];
        }
      },
    },
    methods: {
      onfocus(e) {
        const modul = this;
        e.preventDefault();
        if (modul.val.length >= 2) {
          modul.getElements(modul.val)
        }
      },
      keyupFn(e) {
        const modul = this;
        e.preventDefault();
        if (e.key === "Enter") {
        }
      },
      doEmit(o){
        const modul = this;
        modul.$emit('input', o);
        modul.modeldata = [];
      },
      getElements(querystring){
        const modul = this;
        console.log("getElements");
        if (querystring && querystring.length >= 2) {
          Api.getElementsByMultiParams({querystring: querystring, deleted:0}).then(function (res) {
            console.log(res);
            if (res && res.result && res.data) {
              modul.modeldata = res.data;
            }
          });
        }
      },
    },
    components: {
      AlertInPage,
    },

  };
</script>

<style scoped="">
  .resultContainer {
    max-height: 400px;
    overflow-y: scroll;
  }
</style>
